<ng-container *ngIf="vm$ | async as vm">
	<app-multiple-user-search
		[label]="label"
		[selectedClients]="selectedClients$ | async"
		(add)="_onAdd($event)"
		(remove)="remove($event)"
		(create)="create($event)"
		(onSelect)="onSelect($event)"
		[skeletonLoading]="skeletonLoading"
		(onInputFocus)="handleOnInputFocus($event)"
		[labelIcon]="AI_ICON"
		[labelToolTip]="(showAiIcon$ | async) ? AI_TOOLTIP : ''"
		[labelIconClasses]="AI_CLASSES"
	></app-multiple-user-search>
	<ng-container *ngIf="!showCreateForm">
		<div [@openClose] class="mt-3" *ngFor="let spouse of spouses$ | async">
			<atomic-message-bar
				type="info"
				class="hover:cursor"
				[clickable]="true"
				(click)="add(spouse)"
				[testHook]="testHooks.MessageBar"
				><p>
					Add <span class="underline">{{ spouse | clientName }}</span> as spouse
				</p></atomic-message-bar
			>
		</div>
	</ng-container>
	<div
		[@openClose]
		*ngIf="showCreateForm"
		class="border border-grey-light p-4 rounded-xl my-2"
	>
		<h4 class="flex-1">Add {{ _clientType }}</h4>
		<app-aps-create-client-side-form
			[minify]="true"
			[showPrimaryClientOption]="isClient"
			[(primaryContact)]="primaryContact"
			[matterClientType]="_clientType"
			[clientName]="search"
			(onCreate)="onClientCreated($event)"
			(onCancel)="onClientCancel($event)"
		>
		</app-aps-create-client-side-form>
	</div>
	<div class="mt-4 flex flex-col-reverse gap-4">
		<ng-container *ngIf="!skeletonLoading; else loadingCards">
			<div *ngFor="let selectedClient of selectedClients$ | async">
				<app-container class="flex">
					<atomic-party-client-card
						[client]="selectedClient.client"
						[kebabOptions]="clientKebabOptions"
						(onKebabSelect)="onKebabSelect(selectedClient.client.id, $event)"
						[hideIdv]="hideIdv"
					></atomic-party-client-card>
					<div
						*ngIf="selectedClient.hasAssociatedContacts"
						class="ml-2 mt-1 flex gap-2 items-center"
					>
						<span>Associated Contacts:</span>
						<ui-button
							preset="EXTRA_LOW_EMPHASIS"
							[label]="selectedClient.associatedContactsButtonText"
							(click)="viewAssociatedContacts(selectedClient.client)"
						></ui-button>
					</div>
				</app-container>
			</div>
			<ng-container *ngIf="showSuggestedClients$ | async">
				<div *ngFor="let client of filteredSuggestedClients$ | async">
					<div class="flex flex-col gap-2">
						<div
							class="flex gap-3 items-center border-orange-500 border-2 rounded-xl p-3"
						>
							<atomic-name-badge
								size="small"
								[bold]="true"
								[firstName]="client?.value?.firstName"
								[lastName]="client?.value?.lastName"
								[icon]="client?.value?.name ? ICON.BUSINESS : null"
							/>
							<h4 class="h4 m-0">{{ client?.value | clientName }}</h4>
						</div>
						<ui-note title="Existing Record Match!" [type]="NOTE_TYPES.WARNING">
							<p class="p-sm">
								We found existing records in your client database that match
								<span class="font-bold">{{ client?.value | clientName }}</span
								>. Please verify before continuing.
							</p>
							<ui-button
								[preset]="BUTTON_PRESETS.LOW_EMPHASIS"
								(click)="openSimilarContactDrawer(client?.value)"
								label="Verify Record"
							/>
						</ui-note>
					</div>
				</div>
			</ng-container>
		</ng-container>
		<ng-template #loadingCards>
			<ui-skeleton-loader type="party-card"></ui-skeleton-loader>
		</ng-template>
	</div>
</ng-container>
